// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"07d8938f","732":"fb53bb7f","977":"d00de07b"}[chunkId] + ".chunk.js";
};